import { convertDate, roundToThreeDecimals } from '../../../helpers/modules';
import React, { useEffect, useState } from 'react';
import logo from '../../../assets/jeunessee.png';

const PrintToPdf = ({
	componentRef,
	orderDetails,
	companies,
	companyInfos,
	companyTotals,
	isAdmin,
	adminCompany,
}) => {
	const companyInf = companyInfos;
	const companyList = Array.isArray(companies) ? companies : [];
	const companyTotalsList = Array.isArray(companyTotals) ? companyTotals : [];
	const [countryMap, setCountryMap] = useState({});
	const [countryNames, setCountryNames] = useState({});

	useEffect(() => {
		fetch('https://cdn.jsdelivr.net/npm/world-countries@4/dist/countries.json')
			.then((res) => res.json())
			.then((data) => {
				const map = {};
				const names = {};
				data.forEach((c) => {
					if (c.cca3 && c.cca2) {
						map[c.cca3] = c.cca2.toLowerCase();
						names[c.cca3] = c.name.common;
					}
				});
				setCountryMap(map);
				setCountryNames(names);
			})
			.catch((err) => console.error('Failed to fetch country codes:', err));
	}, []);

	const getFlagUrl = (cca3) => {
		if (!cca3 || !countryMap[cca3]) return null;
		return `https://hatscripts.github.io/circle-flags/flags/${countryMap[cca3]}.svg`;
	};

	const getCountryName = (cca3) => {
		return countryNames[cca3] || cca3;
	};

	const shopCountry = orderDetails?.order?.shopInfo?.country;

	const hasCompany = () => {
		return orderDetails?.order?.clientInfo?.companyClient ? true : false;
	};

	const calculatePlatformFee = () => {
		if (!hasCompany()) return 0;
		const total = orderDetails?.order?.total || 0;
		return total * 0.1;
	};

	const platformFee = calculatePlatformFee();

	const displayLogo =
		isAdmin && adminCompany?.image?.secure_url ? adminCompany.image.secure_url : logo;

	return (
		<div className='order-pdf' ref={componentRef}>
			{/* Logo Top Right */}
			<div className='pdf-logo-container'>
				<img src={displayLogo} alt='Logo' className='pdf-logo-img' />
			</div>

			<div className='devis'>
				<h4>DEVIS</h4>
				<div className='info'>
					<div>
						<label>Numéro:</label>
						<label>Date:</label>
						<label>Référence code client:</label>
					</div>
					<div>
						<span>{orderDetails?.order?.reference ?? '-'}</span>
						<span>{convertDate(orderDetails?.order?.date, 'DD-MM-YYYY') ?? ''}</span>
						<span>
							{orderDetails?.order?.clientInfo?.customs_code
								? orderDetails.order.clientInfo.customs_code
								: '-'}
						</span>{' '}
					</div>
				</div>
			</div>

			<div className='general-info'>
				<div className='left'>
					<h2 className='infos-societe'>JEUN'ESS MARKET</h2>
					<div className='address'>
						<span>VTE EN GROS ART DE MENAGE</span>
					</div>
				</div>
				<div className='right'>
					<h3>{orderDetails?.order?.clientInfo?.company_name ?? ''}</h3>
					<p>{orderDetails?.order?.clientInfo?.client ?? ''}</p>
					<p>
						Matricule Fiscale:{' '}
						{orderDetails?.order?.clientInfo?.tax_registration_number
							? orderDetails.order.clientInfo.tax_registration_number
							: '-'}
					</p>{' '}
					<p>Telephone: {orderDetails?.order?.clientInfo?.phone ?? ''}</p>
					<span>{orderDetails?.order?.shopInfo?.address_number} </span>
					<span>{orderDetails?.order?.shopInfo?.street} </span>
					<span>{orderDetails?.order?.shopInfo?.ville} </span>
					<span>{orderDetails?.order?.shopInfo?.postal_code} </span>
					<span>{orderDetails?.order?.shopInfo?.region} </span>
					{shopCountry && (
						<div style={{ marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
							{getFlagUrl(shopCountry) && (
								<img
									src={getFlagUrl(shopCountry)}
									alt={getCountryName(shopCountry)}
									width='16'
									height='16'
									style={{ borderRadius: '50%' }}
								/>
							)}
							<span style={{ fontSize: '0.625rem', color: '#0f172a', fontWeight: 500 }}>
								{getCountryName(shopCountry)}
							</span>
						</div>
					)}
				</div>
			</div>

			{isAdmin && (
				<div
					className='platform-fee-print'
					style={{
						margin: '10px 0',
						padding: '10px',
						border: hasCompany() ? '2px solid #FFA000' : '2px solid #4CAF50',
						borderRadius: '5px',
						backgroundColor: hasCompany() ? '#FFF3CD' : '#E8F5E9',
					}}
				>
					<h3
						style={{
							margin: '0 0 5px 0',
							fontSize: '12px',
							color: hasCompany() ? '#856404' : '#2E7D32',
						}}
					>
						{hasCompany() ? '📢 Frais de Plateforme Marketing' : '✅ Frais de Plateforme Marketing'}
					</h3>
					{hasCompany() ? (
						<p style={{ margin: '0', fontSize: '10px', color: '#856404' }}>
							<strong>10% du montant total</strong> de cette commande sera prélevé pour la
							plateforme afin de soutenir les objectifs marketing. Montant total :{' '}
							<strong>{roundToThreeDecimals(orderDetails?.order?.total || 0)} DT</strong> → Frais de
							plateforme (10%) : <strong>{roundToThreeDecimals(platformFee)} DT</strong>
						</p>
					) : (
						<p style={{ margin: '0', fontSize: '10px', color: '#2E7D32' }}>
							Aucun frais de marketing n'est appliqué car le client n'est pas associé à une
							entreprise. Frais de plateforme : <strong>0 DT</strong>
						</p>
					)}
				</div>
			)}

			<div className='cher-client'>
				<p>
					Cher Client,
					<br />
					Nous avons bien reçu votre demande de devis et nous vous en remercions.
					<br />
					Nous vous prions de trouver ci-dessous nos conditions les meilleures
				</p>
			</div>

			<div className='devis-table'>
				<table className='offres' style={{ width: '100%', borderCollapse: 'collapse' }}>
					<thead>
						<tr id='titres' style={{ backgroundColor: '#f6f6f6', border: '1px solid #cbd5e1' }}>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								RÉFÉRENCE
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								RÉFÉRENCE CLT
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								DÉSIGNATION
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								SOCIÉTÉ
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								QTÉ
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								PU HT
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								REMISE (%)
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								TVA (%)
							</th>
							<th
								style={{
									padding: '8px',
									textAlign: 'left',
									fontSize: '10px',
									border: '1px solid #cbd5e1',
								}}
							>
								MONTANT HT
							</th>
						</tr>
					</thead>
					<tbody>
						{orderDetails?.list?.map((el, index) => (
							<tr key={index} style={{ borderBottom: '1px solid #cbd5e1' }}>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.reference ?? '-'}
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.refranceCTL ?? '-'}
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.designation ?? '-'}
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.company_name ?? '-'}
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.quantity ?? '-'}
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{roundToThreeDecimals(el?.prise_product_HT ?? 0)} DT
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.remise ?? 0}%
								</td>
								<td style={{ padding: '6px', fontSize: '9px', borderRight: '1px solid #cbd5e1' }}>
									{el?.tva ?? 0}%
								</td>
								<td style={{ padding: '6px', fontSize: '9px' }}>
									{roundToThreeDecimals(el?.montantHT ?? 0)} DT
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{companyTotalsList.length > 0 && (
				<div className='company-totals-print'>
					<h3>Totaux par société</h3>
					<table className='totals-table' style={{ width: '100%', borderCollapse: 'collapse' }}>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #cbd5e1',
										padding: '6px',
										fontSize: '10px',
										backgroundColor: '#f6f6f6',
									}}
								>
									SOCIÉTÉ
								</th>
								<th
									style={{
										border: '1px solid #cbd5e1',
										padding: '6px',
										fontSize: '10px',
										backgroundColor: '#f6f6f6',
									}}
								>
									TOTAL HT
								</th>
								<th
									style={{
										border: '1px solid #cbd5e1',
										padding: '6px',
										fontSize: '10px',
										backgroundColor: '#f6f6f6',
									}}
								>
									TVA
								</th>
								<th
									style={{
										border: '1px solid #cbd5e1',
										padding: '6px',
										fontSize: '10px',
										backgroundColor: '#f6f6f6',
									}}
								>
									TIMBRE
								</th>
								<th
									style={{
										border: '1px solid #cbd5e1',
										padding: '6px',
										fontSize: '10px',
										backgroundColor: '#f6f6f6',
									}}
								>
									TOTAL TTC
								</th>
							</tr>
						</thead>
						<tbody>
							{companyTotalsList.map((company, idx) => (
								<tr key={idx}>
									<td style={{ border: '1px solid #cbd5e1', padding: '4px', fontSize: '9px' }}>
										{company.company_name}
									</td>
									<td style={{ border: '1px solid #cbd5e1', padding: '4px', fontSize: '9px' }}>
										{roundToThreeDecimals(company.total_HT)} DT
									</td>
									<td style={{ border: '1px solid #cbd5e1', padding: '4px', fontSize: '9px' }}>
										{roundToThreeDecimals(company.tva)} DT
									</td>
									<td style={{ border: '1px solid #cbd5e1', padding: '4px', fontSize: '9px' }}>
										{roundToThreeDecimals(company.timbre)} DT
									</td>
									<td style={{ border: '1px solid #cbd5e1', padding: '4px', fontSize: '9px' }}>
										{roundToThreeDecimals(company.total)} DT
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}

			<div className='total-devis'>
				<div id='box'>
					<div>
						<h1>TOTAL HT</h1>
						<span>{roundToThreeDecimals(orderDetails?.order?.total_HT ?? 0)} DT</span>
					</div>
					{isAdmin &&
						orderDetails?.order?.tvaValues?.map((tva, idx) => (
							<div key={idx}>
								<h1>TVA ({tva.tva}%)</h1>
								<span>{roundToThreeDecimals(tva.tvaAmount)} DT</span>
							</div>
						))}
					<div>
						<h1>TIMBRE</h1>
						<span>{roundToThreeDecimals(orderDetails?.order?.timbre ?? 0)} DT</span>
					</div>
					<div>
						<h1>TOTAL TTC</h1>
						<span>{roundToThreeDecimals(orderDetails?.order?.total ?? 0)} DT</span>
					</div>
					{isAdmin && (
						<div style={{ borderTop: '2px solid #FFA000', paddingTop: '10px', marginTop: '10px' }}>
							<h1 style={{ color: hasCompany() ? '#D32F2F' : '#4CAF50' }}>FRAIS MARKETING (10%)</h1>
							<span style={{ color: hasCompany() ? '#D32F2F' : '#4CAF50' }}>
								{roundToThreeDecimals(platformFee)} DT
							</span>
						</div>
					)}
				</div>
			</div>

			<div className='message'>
				<p>
					Nous sommes à votre disposition pour tout complément d'informations.
					<br />
					Nous vous prions d'agréer, Cher Client, nos sincères salutations.
					<br />
					Le service commercial.
				</p>
			</div>

			<div className='footer'>
				{companyInf && (
					<div className='left'>
						<ul>
							<li>
								Company Name : <strong>{companyInf?.name || '-'}</strong>
							</li>
							<li>Company Address : {companyInf?.address || '-'}</li>
							<li>
								CODE TVA : <span>{companyInf?.tva_code || '-'}</span>
							</li>
							<li>
								RC : <span>{companyInf?.r_c || '-'}</span>
							</li>
							<li>
								Code en Douane : <span>{companyInf?.customs_code || '-'}</span>
							</li>
							<li>
								Tél : <span>{companyInf?.phone || '-'}</span>
							</li>
							<li>
								Fax : <span>{companyInf?.fax || '-'}</span>
							</li>
							<li>
								Email : <span>{companyInf?.email || '-'}</span>
							</li>
						</ul>
					</div>
				)}
				{companyList.map((company, index) => (
					<div className='left' key={company?._id || index}>
						<ul>
							<li>
								Company Name : <strong>{company?.name || '-'}</strong>
							</li>
							<li>Company Address : {company?.address || '-'}</li>
							<li>
								CODE TVA : <span>{company?.tva_code || '-'}</span>
							</li>
							<li>
								RC : <span>{company?.r_c || '-'}</span>
							</li>
							<li>
								Code en Douane : <span>{company?.customs_code || '-'}</span>
							</li>
							<li>
								Tél : <span>{company?.phone || '-'}</span>
							</li>
							<li>
								Fax : <span>{company?.fax || '-'}</span>
							</li>
							<li>
								Email : <span>{company?.email || '-'}</span>
							</li>
						</ul>
					</div>
				))}
			</div>
		</div>
	);
};

export default PrintToPdf;
